import { render, staticRenderFns } from "./sme-preimum.vue?vue&type=template&id=054e7972&scoped=true&"
import script from "./sme-preimum.vue?vue&type=script&lang=js&"
export * from "./sme-preimum.vue?vue&type=script&lang=js&"
import style0 from "./sme-preimum.vue?vue&type=style&index=0&id=054e7972&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054e7972",
  null
  
)

export default component.exports